import React from "react";
import styled from "styled-components";
import { Table } from "antd";

const StyledTable = styled(Table)`
  .ant-table-thead > tr > th {
    background-color: #f5f5f5;
    color: #333;
  }
  .ant-table-tbody > tr > td {
    color: #555;
    padding: 12px 15px !important;
  }
  .ant-table-thead > tr > th.ant-table-column-has-sorters:hover {
    background-color: #e0e0e0;
  }
  .ant-table-thead > tr > th .ant-table-filter-column-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }

  .ant-pagination-item a {
    display: block;
    padding: 0 6px;
    // color: rgb(70, 217, 147);
    transition: none;
  }

  .ant-pagination-jump-prev
    .ant-pagination-item-container
    .ant-pagination-item-ellipsis,
  .ant-pagination-jump-next
    .ant-pagination-item-container
    .ant-pagination-item-ellipsis {
    color: rgb(70, 217, 147);
  }
  .ant-pagination-item {
    border: none;
  }

  .ant-pagination-item-active a {
    border-radius: 20px;
    background-color: rgb(70, 217, 147);
    border: none;
    color: black;
  }

  .ant-pagination-prev button,
  .ant-pagination-next button {
    color: rgb(70, 217, 147);
  }

  .ant-select:not(.ant-select-customize-input) .ant-select-selector {
    border: none;
    border-radius: 5px;
    color: black;
    background-color: white;
  }

  .ant-select-arrow {
    color: black;
  }
`;

const CustomTable = ({
  columns,
  data,
  onChange,
  sorterTooltipConfig,
  pagination,
  ...rest
}) => (
  <StyledTable
    bordered
    columns={columns}
    dataSource={data}
    onChange={onChange}
    showSorterTooltip={sorterTooltipConfig}
    pagination={pagination}
    {...rest}
  />
);

CustomTable.defaultProps = {
  onChange: (pagination, filters, sorter, extra) => {
    console.log("params", pagination, filters, sorter, extra);
  },
  sorterTooltipConfig: {
    target: "sorter-icon",
  },
};

export default CustomTable;
